<div [ngClass]="(!isEnglish()) ? 'middle-de' : 'middle-en'">
    <button [disabled]="!(isRightSideEnable && isLeftSideEnable)" mat-flat-button color="primary" (click)="rotateLens()">
        <fa-icon [icon]="arrowLeft"></fa-icon>
        {{"newOrder.buttons.rotate" | translate}}
        <fa-icon [icon]="arrowRight"></fa-icon>
    </button>
</div>

<div class="d-flex head">
    <div (click)="togglePlusFinalLensRightSide()" class="plus-container">
        <span class="add" #plusCrossFinalLensRight><fa-icon size="2x" [icon]="plusIcon"></fa-icon></span>
    </div>
    <div (click)="togglePlusFinalLensRightSide()" *ngIf="isRightSideEnable" class="cross-label-left">{{"common.buttons.remove" | translate}}</div>
    <div (click)="togglePlusFinalLensRightSide()" *ngIf="!isRightSideEnable" class="cross-label-left">{{"common.buttons.add" | translate}}</div>

    <div (click)="togglePlusFinalLensLeftSide()" *ngIf="isLeftSideEnable" class="cross-label-right">{{"common.buttons.remove" | translate}}</div>
    <div (click)="togglePlusFinalLensLeftSide()" *ngIf="!isLeftSideEnable" class="cross-label-right">{{"common.buttons.add" | translate}}</div>
    <div (click)="togglePlusFinalLensLeftSide()" class="plus-container">
        <span class="add" #plusCrossFinalLensLeft><fa-icon size="2x" [icon]="plusIcon"></fa-icon></span>
    </div>
</div>

<div class="d-flex">
    <app-final-lens [style.visibility]="isRightSideEnable ? 'visible': 'hidden'" class="final-lens-step" [side]="LensSide.RIGHT" (copyEmit)="copy($event)" (switchEmit)="switch($event)" #finalLensRight></app-final-lens>
    <div class="delimeter-final-lens"></div>
    <app-final-lens [style.visibility]="isLeftSideEnable ? 'visible': 'hidden'" class="final-lens-step" [side]="LensSide.LEFT" (copyEmit)="copy($event)" (switchEmit)="switch($event)" #finalLensLeft></app-final-lens>
</div>
<div class="remote-error">
  <label class="check">{{remoteErrorRight}}</label>
  <div class="delimiter-remote"></div>
  <label class="check">{{remoteErrorLeft}}</label>
</div>
<div class="footer"></div>
<div class="d-flex">
    <button mat-flat-button color="primary" *ngIf="finalLensRight.isEditFinalLens || finalLensLeft.isEditFinalLens" [ngClass]="(!isEnglish()) ? 'action-button-de' : 'action-button-en'" (click)="addLenses()">{{"newOrder.finalLens.updateItem" | translate}}</button>
    <button mat-flat-button color="primary" *ngIf="!finalLensRight.isEditFinalLens && !finalLensLeft.isEditFinalLens" [ngClass]="(!isEnglish()) ? 'action-button-de' : 'action-button-en'" (click)="addLenses()">{{"newOrder.finalLens.addToCart" | translate}}</button>
</div>
